// Professional Scroll Animations
document.addEventListener('DOMContentLoaded', function() {
  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        
        // Add staggered animation to child elements
        const children = entry.target.querySelectorAll('.animate-child');
        children.forEach((child, index) => {
          setTimeout(() => {
            child.classList.add('animate-fade-in-up');
          }, index * 100);
        });
      }
    });
  }, observerOptions);

  // Observe all elements with scroll-reveal class
  const scrollElements = document.querySelectorAll('.scroll-reveal');
  scrollElements.forEach(el => observer.observe(el));

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Parallax effect for hero background
  const heroBackground = document.querySelector('.hero-4thecrowd__background');
  if (heroBackground) {
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const rate = scrolled * -0.5;
      heroBackground.style.transform = `translateY(${rate}px)`;
    });
  }

  // Counter animation for numbers
  const counters = document.querySelectorAll('.counter');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = parseInt(counter.getAttribute('data-target'));
        const duration = 2000; // 2 seconds
        const increment = target / (duration / 16); // 60fps
        let current = 0;
        
        const updateCounter = () => {
          current += increment;
          if (current < target) {
            counter.textContent = Math.floor(current);
            requestAnimationFrame(updateCounter);
          } else {
            counter.textContent = target;
          }
        };
        
        updateCounter();
        counterObserver.unobserve(counter);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => counterObserver.observe(counter));

  // Typing animation for text
  const typingElements = document.querySelectorAll('.typing-animation');
  typingElements.forEach(element => {
    const text = element.textContent;
    element.textContent = '';
    element.style.borderRight = '2px solid #ff0000';
    
    let i = 0;
    const typeWriter = () => {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(typeWriter, 100);
      } else {
        element.style.borderRight = 'none';
      }
    };
    
    const typingObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          typeWriter();
          typingObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    typingObserver.observe(element);
  });

  // Loading animation
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
    
    // Remove loading screen if it exists
    const loadingScreen = document.querySelector('.loading-screen');
    if (loadingScreen) {
      loadingScreen.style.opacity = '0';
      setTimeout(() => {
        loadingScreen.style.display = 'none';
      }, 500);
    }
  });

  // Mobile menu animation
  const mobileMenu = document.querySelector('.header-4thecrowd__center');
  const hamburger = document.querySelector('.header-4thecrowd__hamburger');
  
  if (mobileMenu && hamburger) {
    hamburger.addEventListener('click', () => {
      document.body.classList.toggle('mobile-menu-open');
      hamburger.classList.toggle('is-active');
      
      // Animate menu items
      const menuItems = mobileMenu.querySelectorAll('.header-4thecrowd__menu-item');
      if (document.body.classList.contains('mobile-menu-open')) {
        menuItems.forEach((item, index) => {
          setTimeout(() => {
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
          }, index * 100);
        });
      } else {
        menuItems.forEach((item) => {
          item.style.opacity = '';
          item.style.transform = '';
        });
      }
    });
  }
});

// Utility function for adding animation classes
function addAnimationClass(element, className, delay = 0) {
  setTimeout(() => {
    element.classList.add(className);
  }, delay);
}

// Utility function for removing animation classes
function removeAnimationClass(element, className) {
  element.classList.remove(className);
}

// Export for use in other scripts
window.ScrollAnimations = {
  addAnimationClass,
  removeAnimationClass
};
